module.exports = __webpack_public_path__ + "media/images/teams/SPEZIA-ad1d6cb2924cf95958b5e59609a7e9a9.png";